<template>
  <div>
    <v-card class="white rounded-lg">
      <v-card-title class="secondary--text">{{ title }}</v-card-title>
      <v-card-text>
        <m-datatable
            :headers="headers"
            :apiUrl="url"
            :filters.sync="filters"
            ref="datatable"
            @dblclick:row="(e, row) => $router.push(to(row.item))"
        >
          <template #item.remain="{ item }">{{ getRemain(item) | toMoney }}</template>
          <template #item.settle="{ item }">
            <v-btn depressed class="rounded-lg" color="info white--text" :to="toSettle(item)" text>تسویه</v-btn>
          </template>
          <template #item.detail="{ item }">
            <detail-link :to="to(item)"/>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import FactorMixin from "@/views/panel/factor/mixin";
import MoadianMixin from "@/modules/moadian/mixin";

export default {
  name: "MoadianFactorsList",
  components: {},
  mixins: [FactorMixin, MoadianMixin],
  props: {
    type: {},
    isPreFactor: {},
  },
  data() {
    return {
      filters: {
      },
      url: "moadian/keysan/factors/",
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('لیست فاکتور های ثبت شده در سامانه مودیان')
    },
    headers() {
      let headers = [
        {
          text: "شماره",
          value: "code",
        },
        {
          text: "تاریخ",
          value: "date",
          type: "date",
        },
        {
          text: ["buy", "backFromBuy"].includes(this.type) ? "فروشنده" : "مشتری",
          value: "account.name",
        },
      ];
      if (this.type == "buy") {
        headers.push({
          text: "شماره فاکتور فروشنده ",
          value: "seller_factor_code",
        });
      }
      headers.push({
        text: "شرح",
        value: "explanation",
      });
      headers.push({
        text: "مبلغ کل فاکتور",
        value: "round_total_sum",
        type: "numeric",
      });

      if (this.type != "cw") {
        headers.push({
          text: "مالیات ",
          value: "has_tax",
          type: "boolean",
        });
      }
      headers.push({
        text: this.type == "buy" ? "پرداخت شده " : "دریافت شده",
        value: "is_settled",
        type: "boolean",
      });
      headers.push({
        text: "موضوع",
        value: "moadian_subject",
        type: "select",
        items: this.invoiceSubjects,
      });
      headers.push({
        text: "جزئیات",
        value: "detail",
        sortable: false,
        filterable: false,
      });

      return headers;
    },
  },
  created() {
    // this.filters.type = this.type;
    // this.filters.is_pre_factor = this.isPreFactor;
  },
  watch: {
    $route() {
      this.$refs.datatable.getDataFromApi();
    },
  },
  methods: {
    to(item) {
      return {
        name: "FactorForm",
        params: {
          isPreFactor: item.is_pre_factor,
          type: item.type,
          id: item.id,
        },
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
